import UI from "./base/UI";
import CountUp from '../libs/countUp.min';
import { isA11yCheckVersion } from "../functions/a11y.ui";

 // ############# 현재 사용안함  ###########
class Counter extends UI {
    defaults = {
        duration: 2
    };
    $counter = {};
    constructor(el, options) {
        super('counter', el);

        this.init(el, options);
    }

    init(el, options) {
        this.defaults = {...this.defaults, ...options};

        this.render();

    }

    update() {
    }

    render() {
        this.detachEvents();
        this.attachEvents();

    }

    attachEvents() {
        this.$el.attr('data-pos-top', this.$el.offset().top )
        var startVal = 0;
        var endVal = this.$el.attr('data-counter-num');
        var decimals = 0;
        this.defaults.duration = this.$el.attr('data-duration') == undefined ? this.defaults.duration : Number(this.$el.attr('data-duration')) / 1000;
        this.$counter = new CountUp(this.el, startVal, endVal, decimals, this.defaults.duration, {
            useEasing : true, // toggle easing
            useGrouping : true, // 1,000,000 : 1000000
            separator : ',', // 구분자로 사용할 문자
            decimal : '.', // 소수점으로 사용할 문자
            prefix : '', // 결과 앞의 텍스트
            suffix : '', // 결과 뒤의 텍스트
        });
    }

    start(){
        this.$counter.start()
    }
    update(){
        this.$counter.update(this.$el.attr('data-counter-num'))
    }

    detachEvents() {
        this.$el.off(this.eventId);
    }

    destroy() {
        this.detachEvents();
    }
}

export default Counter;
